import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, retry, tap, timer } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConnectivityErrorDialogComponent } from '../../ui-kit/dialogs/connectivity-error-dialog/connectivity-error-dialog.component';

@Injectable()
export class ConnectivityErrorInterceptor implements HttpInterceptor {

  private readonly retryCount = 5

  constructor(private readonly dialog: MatDialog) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: Infinity,
        delay: (error: any, retryCount: number) => {
          if (error.status >= 502 && error.status <= 504) {

            const dialog = this.dialog.open(ConnectivityErrorDialogComponent,
              ConnectivityErrorDialogComponent.createConfigurations(retryCount >= this.retryCount)
            )

            return retryCount < this.retryCount ?
              timer(2200 * retryCount).pipe(tap(() => dialog.close())) :
              dialog.afterClosed()
          }

          throw error
        },
        resetOnSuccess: false
      })
    )
  }
}

